export class AccountInformationDetails {
  hasCustomerRecord: boolean
  firstName: string
  lastName: string
  phoneNumber: string
  addressLine1: string
  addressLine2: string
  city: string
  stateId?: number
  postalCode: string

  constructor(hasCustomerRecord: boolean, firstName: string|undefined, lastName: string|undefined, phoneNumber: string|undefined, addressLine1: string|undefined, addressLine2: string|undefined, city: string|undefined, stateId: number|undefined, postalCode: string|undefined) {
    this.hasCustomerRecord = hasCustomerRecord
    this.firstName = firstName ?? ''
    this.lastName = lastName ?? ''
    this.phoneNumber = phoneNumber ?? ''
    this.addressLine1 = addressLine1 ?? ''
    this.addressLine2 = addressLine2 ?? ''
    this.city = city ?? ''
    this.stateId = stateId
    this.postalCode = postalCode ?? ''
  }
}
